import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useTravelSafetyAdvisory from '../../hooks/useTravelSafetyAdvisory';
var getLocationIdFromUrl = function () {
    return new URLSearchParams(window.location.search).get('location_id');
};
var TravelSafetyAdvisory = function () {
    var placeId = useSelector(function (state) { var _a, _b; return (_b = (_a = state.search) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.placeId; });
    var locationIds = useMemo(function () {
        var id = placeId || getLocationIdFromUrl();
        return id ? [id] : [];
    }, [placeId]);
    useTravelSafetyAdvisory(locationIds, 'search');
    return null;
};
export default TravelSafetyAdvisory;
